/* TCG filter page motion (GSAP) — rides tcg-filter.js's lifecycle purely via
   observers; never touches its logic, timing, or DOM ownership. Same safety
   model as lsc-motion.js: entrance-only, gsap.from (fail-safe), and because
   tcg-filter.js REUSES card nodes across renders (detach → pen → re-append),
   every pass kills tweens and clears inline styles before animating — a reused
   node must never carry stale opacity from an interrupted tween. */
(function () {
  'use strict';
  if (!window.gsap) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var MOB = window.matchMedia('(max-width: 749px)');
  function q(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight && r.bottom > 0;
  }

  q('[data-tcgf]').forEach(function (root) {
    var grid = root.querySelector('[data-tcgf-grid]');
    if (!grid) return;

    /* ---------- per-render choreography (mode switch, facets, chips, boot) ----------
       render() rebuilds the mount in one burst; coalesce via rAF, then:
       hygiene pass (kill + clear EVERY item — node reuse!), then stagger the
       in-viewport slice. Entrance-only; below-fold items appear instantly. */
    var pending = false;
    function onRender() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        var items = q('.tcgf__list > li', grid);
        var heads = q('.tcgf__era-head, .tcgf__shelf-head', grid);
        gsap.killTweensOf(items.concat(heads));
        gsap.set(items.concat(heads), { clearProps: 'opacity,transform,visibility' });
        var visItems = items.filter(inView).slice(0, MOB.matches ? 8 : 14);
        var visHeads = heads.filter(inView).slice(0, 4);
        if (visHeads.length) gsap.from(visHeads, { autoAlpha: 0, y: 10, duration: 0.4, ease: 'power3.out', stagger: 0.05, clearProps: 'opacity,transform,visibility', overwrite: 'auto' });
        if (visItems.length) gsap.from(visItems, { autoAlpha: 0, y: 12, duration: 0.4, ease: 'power2.out', stagger: { each: MOB.matches ? 0.025 : 0.035, grid: 'auto' }, clearProps: 'opacity,transform,visibility', overwrite: 'auto' });
      });
    }
    new MutationObserver(onRender).observe(grid, { childList: true });

    /* ---------- boot: when the engine flips live, ease the chrome in ---------- */
    var booted = false;
    function boot() {
      if (booted) return;
      booted = true;
      var bar = root.querySelector('.tcgf__toolbar');
      var era = root.querySelector('[data-tcgf-erabar]');
      var chrome = (bar ? q(':scope > *', bar) : []).concat(era && !era.hidden ? [era] : []);
      if (chrome.length) gsap.from(chrome, { autoAlpha: 0, y: -8, duration: 0.45, ease: 'power3.out', stagger: 0.06, clearProps: 'all', overwrite: 'auto' });
      onRender(); /* first grid build may predate this attribute flip */
    }
    if (root.getAttribute('data-js-active') === 'true') boot();
    else new MutationObserver(function () {
      if (root.getAttribute('data-js-active') === 'true') boot();
    }).observe(root, { attributes: true, attributeFilter: ['data-js-active'] });

    /* ---------- product count tick ---------- */
    var count = root.querySelector('[data-tcgf-count]');
    if (count) new MutationObserver(function () {
      if (gsap.getTweensOf(count).length) return;
      gsap.from(count, { autoAlpha: 0.35, y: 4, duration: 0.25, ease: 'power1.out', clearProps: 'all' });
    }).observe(count, { childList: true, characterData: true, subtree: true });

    /* ---------- chips: fade fresh ones in (removal stays instant) ---------- */
    var chips = root.querySelector('[data-tcgf-chips]');
    if (chips) new MutationObserver(function (muts) {
      var fresh = [];
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1) fresh.push(n); });
      });
      if (fresh.length) gsap.from(fresh, { autoAlpha: 0, y: 4, duration: 0.25, ease: 'power2.out', stagger: 0.03, clearProps: 'all', overwrite: 'auto' });
    }).observe(chips, { childList: true });

    /* ---------- facet groups: settle in when (re)built ---------- */
    var facets = root.querySelector('[data-tcgf-facets]');
    if (facets) {
      var fPending = false;
      new MutationObserver(function () {
        if (fPending) return;
        fPending = true;
        requestAnimationFrame(function () {
          fPending = false;
          var rows = q(':scope > *', facets).slice(0, 12);
          if (!rows.length) return;
          gsap.killTweensOf(rows);
          gsap.set(rows, { clearProps: 'opacity,transform,visibility' });
          gsap.from(rows, { autoAlpha: 0, y: 6, duration: 0.3, ease: 'power2.out', stagger: 0.03, clearProps: 'opacity,transform,visibility', overwrite: 'auto' });
        });
      }).observe(facets, { childList: true });
    }

    /* ---------- empty state ---------- */
    var empty = root.querySelector('[data-tcgf-empty]');
    if (empty) new MutationObserver(function () {
      if (empty.hidden) return;
      var kids = q(':scope > *', empty).filter(function (n) { return !n.hidden; });
      if (kids.length) gsap.from(kids, { autoAlpha: 0, y: 10, duration: 0.4, ease: 'power3.out', stagger: 0.06, clearProps: 'all', overwrite: 'auto' });
    }).observe(empty, { attributes: true, attributeFilter: ['hidden'] });
  });
})();
